import SwiperGalleries from './SwiperGallery';

const Buy = function ()
{

    const colorProductChange = (e) => {

        const _this = $(e.currentTarget);

        const idProduct    = _this.data('id_product');
        const idSku    = _this.data('sku');
        
        $('#id_product').val(idProduct);
        $('#form-data-sku').val(idSku);

        SwiperGalleries.galleryViewDinamic();
    }

    const toogleActiveElement = (e) => {

        const _this = $(e.currentTarget);
        
        if(_this.hasClass('toDisableClass--col')){
            $('.list-add-item--col').find('.el-class-toggle').removeClass('actived');
        }
        
        // button
        _this.parent().find('.el-class-toggle').removeClass('actived');//.addClass('disabled');
        $(_this).addClass('actived');//.removeClass('disabled')

        // desabilita titulo de cada bloco de compra
        _this.closest('.wrap-step').addClass('opt-selected').find('.text-step').addClass('disabled');
        _this.closest('.wrap-step.opt-selected').find('.text-step').removeClass('disabled');

        
        if($(_this).closest('.wrap-options-color').length > 0){
            $(_this).closest('.wrap-options-color').addClass('one-color-selected')
        }
        
    }
    
    const disabledNextStep = (e) => {
        
        const _this         = $(e.currentTarget);
        const disabledEl    = _this.data('next');

        // console.log(disabledEl);

        // cores guia
        let arrId = ['#list-add-item--37','#list-add-item--33','#list-add-item--29']

        if(arrId.includes(disabledEl)){
            $('.wrap-step').find('.text-step').removeClass('disabled');
        }

        if(_this.hasClass('toDisableClass--col')){
            $('.list-add-item--col').addClass('disabled').css('display','none');
            $(disabledEl).removeClass('disabled').css('display','flex');
            $('#next-bt-add').addClass('disabled');
        }

        $(disabledEl).removeClass('disabled');

    }

    const getPriceDinamic = (e) => {
        const _this                 = $(e.currentTarget);
        const idPriceDinamic        = $("#price-dinamic-for-product");
        const idPriceParcelDinamic  = $("#price-parcel-dinamic-for-product");
        const brl = (v) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        const price     = Number(_this.attr('data-price_dinamic'));
        const priceFrom = _this.attr('data-price_dinamic_from');

        idPriceDinamic.html(
            priceFrom
                ? `<del>${brl(priceFrom)}</del> <span class="infos-text">por</span> <b>${brl(price)}</b>`
                : `<b>${brl(price)}</b>`
        );

        idPriceParcelDinamic.text(brl(price / 4));

        //atualiza o produto para enviar ao carrinho
        $("#id_product").val(_this.attr('data-id_product'));
        $("#form-data-sku").val(_this.attr('data-sku'));
    }

    return {
        init: function () {

            // func add id product in the hidden field
            $(document).on('click', '.act-bt-color:not(.action-add-component), .product-selected-opt', colorProductChange)

            // func add and remove class element selected
            $(document).on('click', '.el-class-toggle', toogleActiveElement)
            
            // remove disable next
            $(document).on('click', '.toDisableClass', disabledNextStep)
            
            // guia - captura valor do combo
            $(document).on('click', '.getPrice', getPriceDinamic)

        }
    }

}();
export default Buy;